export function AppFooter() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-card shadow-sm border-t p-2 sm:p-3 md:p-4 flex flex-col sm:flex-row items-center justify-between z-10 gap-2 sm:gap-0 mt-auto">
      <div className="flex items-center text-xs sm:text-sm text-muted-foreground">
        <span>© {currentYear}, feito com ❤️ por AuraCode 🌟</span>
      </div>
      
      <div className="flex items-center text-xs sm:text-sm text-muted-foreground text-center sm:text-right">
        <span className="hidden md:inline">CNPJ: 57.787.135/0001-66 | Avenida Paulista, 777, Sala 102 - São Paulo, SP</span>
        <span className="md:hidden">CNPJ: 57.787.135/0001-66</span>
      </div>
    </footer>
  );
}